import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset from "models/NotificationAsset"

export interface IGetNotificationCollectiveReferenceNumberUpdatedDto extends IGetNotification {
    notificationType: NotificationType.collectiveReferenceNumberUpdated
    machineAssetId: Guid
    assets: Guid[]
    sale: boolean
}

export default class NotificationCollectiveReferenceNumberUpdated extends Notification {
    machineAssetId: Guid
    machineAsset: NotificationAsset
    assetIds: Guid[]
    assets: NotificationAsset[]
    sale: boolean

    constructor(dto: IGetNotificationCollectiveReferenceNumberUpdatedDto) {
        super(dto)

        this.machineAssetId = dto.machineAssetId
        this.machineAsset = new NotificationAsset({
            assetId: dto.machineAssetId
        })

        this.assetIds = dto.assets
        this.assets = dto.assets.map(assetId => new NotificationAsset({
            assetId: assetId
        }))

        this.sale = dto.sale
    }
}
